import { IEntity } from "@interfaces/entity";

export class Manufacturer implements IEntity {
  id: string;
  name: string;

  entityName = "Manufacturer";

  constructor(formValue?: Partial<Manufacturer>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }

  updateValues(formValue: Partial<Manufacturer>) {
    Object.assign(this, formValue);
  }
}
